<template>
    <div>
        <app-nav/>
        <main>
            <section>
                <div class="row d-flex justify-content-center m-0 p-0">
                    <div class="col taust w-100">
                        <div class="row d-flex mob-bg justify-content-center m-0 p-0 wow fadeIn">
                            <div class="col top-m-p text-center w-100">
                                <h1 class="display-5 font-weight-normal mt-1 mb-4 custom-mob-bg">
                                    {{ $t('Contact') }}
                                </h1>
                                <div class="container">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <div v-if="page" class="text-left" v-html="page[locale]"></div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <iframe scrolling="no"
                                                    marginheight="0"
                                                    marginwidth="0"
                                                    id="gmap_canvas"
                                                    src="https://maps.google.com/maps?width=520&height=400&hl=en&q=1autorent%20Tallinn+(Autorent%20O%C3%9C%20-%201autorent)&t=&z=17&ie=UTF8&iwloc=B&output=embed"
                                                    width="100%"
                                                    height="400"
                                                    frameborder="0"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <app-footer/>
    </div>
</template>

<script>
import AppNav from '@components/layout/public/Nav';
import AppFooter from '@components/layout/public/Footer';
import PublicPageService from '@services/publicPage.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            page: null,
        };
    },
    computed: {
        ...mapGetters(['locale']),
    },
    methods: {
        getPage() {
            PublicPageService.publicShow('contact').then(res => {
                this.page = res;
            });
        }
    },
    components: {
        AppNav,
        AppFooter
    },
    created() {
        this.getPage();
    },
    metaInfo() {
        return {
            title: `${this.$t('Contact')} | Autorent OÜ`,
            script: [
                { src: 'https://embedmaps.com/google-maps-authorization/script.js?id=b442a5f6718299be4746ca7849b28999b19bf520'}
            ],
        };
    }
};
</script>
